import { create } from "zustand";

import { ContactPanelTabIds } from "./types/contact-panel-tab-ids";
import { TimelineEventTypeEnum } from "@hd/types/dto/contact/enums/timeline-event-type";

export interface ContactPanelState {
  isOpen: boolean;
  isSubPanelOpen: boolean;
  contactId: number | null;
  companyId: number | null;
  companyName: string | null;
  selectedTabId: ContactPanelTabIds;
  presetMessage: string | null;
  categoryId: TimelineEventTypeEnum | null;
  categoryItemId: string | null;
  open(
    contactId: number,
    companyId: number,
    selectedTabId: ContactPanelTabIds | number
  ): void;
  openActivityHistoryAtItem(
    contactId: number,
    companyId: number,
    categoryId: TimelineEventTypeEnum,
    categoryItemId: string
  ): void;
  close(): void;
  changeCompany(companyId: number, companyName: string): void;
  changeTab(selectedTabId: ContactPanelTabIds): void;
  toggleSubPanel(): void;
  selectPresetMessage(text: string): void;
}

export const useContactPanelStore = create<ContactPanelState>((set) => {
  return {
    isOpen: false,
    isSubPanelOpen: false,
    contactId: null,
    companyId: null,
    companyName: null,
    selectedTabId: ContactPanelTabIds.CONVERSATION,
    presetMessage: null,
    categoryId: null,
    categoryItemId: null,
    open: (
      contactId: number,
      companyId: number,
      selectedTabId: ContactPanelTabIds | number
    ) => {
      if (typeof selectedTabId !== "number") {
        set((s) => ({
          isOpen: true,
          isSubPanelOpen: false,
          contactId,
          companyId,
          companyName: s.companyName,
          selectedTabId,
        }));
      } else {
        set((s) => ({
          isOpen: true,
          isSubPanelOpen: false,
          contactId,
          companyId,
          companyName: s.companyName,
          selectedTabId:
            ContactPanelTabIds[
              Object.keys(ContactPanelTabIds)[
                selectedTabId
              ] as keyof typeof ContactPanelTabIds
            ],
        }));
      }
    },
    openActivityHistoryAtItem: (
      contactId: number,
      companyId: number,
      categoryId: TimelineEventTypeEnum,
      categoryItemId: string
    ) => {
      set((s) => ({
        isOpen: true,
        isSubPanelOpen: false,
        contactId,
        companyId,
        companyName: s.companyName,
        categoryId,
        categoryItemId,
        selectedTabId: ContactPanelTabIds.ACTIVITY_HISTORY,
      }));
    },
    toggleSubPanel: () =>
      set((s) => ({ isSubPanelOpen: !s.isSubPanelOpen, presetMessage: null })),
    close: () =>
      set(() => ({
        isOpen: false,
        isSubPanelOpen: false,
        presetMessage: null,
        categoryId: null,
        categoryItemId: null,
      })),
    changeCompany(companyId, companyName) {
      set(() => ({ companyId, companyName }));
    },
    changeTab: (selectedTabId: ContactPanelTabIds) =>
      set(() => ({ selectedTabId })),
    selectPresetMessage: (text: string) => set(() => ({ presetMessage: text })),
  };
});
